module.exports = __webpack_public_path__ + "static/media/rj_result_scooter3.94463646.png";